const Footer = ({ version, isDev }) => {

  return (
    <footer>
      &copy;2023 - 2025 <a href="https://studentregister.au" target="_blank" rel="noreferrer">Student Register</a> (v {version})
      {isDev === 'DEV' && <p className='marquee'>Development Server!</p>}
    </footer>
  )
}

export default Footer